module.exports = require('./LicenseOfficeManagerChangeApplicationView');
